module.exports = require('./LicenseOfficeManagerChangeApplicationView');
